module.exports = __webpack_public_path__ + "static/media/Portrait-10014-halloween.45365a37.jpg";